import { Edit } from 'react-admin';
import { FormFields } from './components';

export const UserEdit = () => (
		<Edit mutationMode="pessimistic">
			{FormFields}
		</Edit>
);

export default UserEdit;